import { EmergencyContactCard } from '@/components/Admin/EmergencyContactCard';
import { InvoicingSettingsCard } from '@/components/Admin/InvoicingSettingsCard';
import { PortalPingCard } from '@/components/Admin/PortalPingCard';
import { SiteSectionsCard } from '@/components/Admin/SiteSectionsCard';
import { TermsSettingsCard } from '@/components/Admin/TermsSettingsCard';

/**
 * Settings for the site as a whole, rather than for anything in the catalog.
 *
 * These were on the dashboard, which is the page you land on to see what is
 * waiting for you — and neither of them ever waits for you. A visibility switch
 * is looked for deliberately, and a connection check is reached for when
 * something already looks wrong, so both belong somewhere you go on purpose.
 */
export function PageSettings() {
  return (
    <div className='tw:mx-auto tw:max-w-6xl'>
      <header className='tw:mb-8'>
        <h1 className='tw:font-serif tw:text-3xl tw:font-light'>Settings</h1>
        <p className='tw:mt-1 tw:text-sm tw:text-muted-foreground'>
          What the public site shows, and how this site connects to the rest of Eighty Days.
        </p>
      </header>

      <div className='tw:space-y-8'>
        <SiteSectionsCard />
        <EmergencyContactCard />
        <TermsSettingsCard />
        <InvoicingSettingsCard />
        <PortalPingCard />
      </div>
    </div>
  );
}
